import { addIncomeLink, removeIncomeLink } from "../utils/paymentIncomeLinks";

// Le store PAYMENTS est indexé par paymentID (formatData(list, "paymentID") dans paymentAction).
// Les paiements modifiés sont copiés : muter l'objet du state précédent empêchait les écrans
// connectés de voir le changement.
export function paymentReducer(state = "",{
    type,
    payload
}){
    switch(type){
        case "GET_PAYMENTS":
            return payload;
        case "UPDATE_PAYMENTS_LINK": {
            // Le lien s'ajoute à ceux qui existent (cumul sur la même recette), avec le montant
            // réellement appliqué par le serveur ; income_id historique maintenu par le helper.
            const amounts = payload.amounts || {}
            const state1 = Object.assign({}, state)
            payload.list.forEach( payID => {
                if (state1[payID]) {
                    state1[payID] = addIncomeLink(state1[payID], payload.income_id, amounts[payID])
                }
            })
            return state1;
        }
        case "UPDATE_PAYMENTS_UNLINK": {
            // Seul le lien vers la recette dépointée disparaît (ou diminue du montant retiré).
            const amounts = payload.amounts || {}
            const state2 = Object.assign({}, state)
            payload.list.forEach( payID => {
                if (state2[payID]) {
                    state2[payID] = removeIncomeLink(state2[payID], payload.income_id, amounts[payID])
                }
            })
            return state2;
        }

        default:
            return state;
    }
}
